import React from 'react';
import { XIcon } from 'lucide-react';
import { PAIN_CLOSING, PAIN_EMPHASIS, PAIN_EMPHASIS_LEAD, PAIN_HEADLINE, PAIN_INTRO, painLines, painQuestions } from '../data/resinContent';
export function PainSection() {
  return <section className="w-full bg-charcoal-950 py-12 sm:py-16" aria-labelledby="pain-title" data-id="element-252" data-mp="2uxm29cjw1xhc">
      <div className="mx-auto max-w-5xl px-5" data-id="element-253" data-mp="2yy60kjg77752">
        <h2 id="pain-title" className="max-w-3xl font-display text-[1.65rem] font-semibold uppercase leading-tight text-ivory-50 sm:text-[2.4rem]" data-id="element-254" data-mp="2l8m41vd7n647">
          {PAIN_HEADLINE}
        </h2>

        <div className="mt-5 space-y-2" data-id="element-255" data-mp="2baodv2bsiz8y">
          {PAIN_INTRO.map(line => <p key={line} className="max-w-2xl text-[15px] leading-relaxed text-ivory-200 sm:text-[16px]" data-id="element-256" data-mp="2g8zr7n1anrvx">
              {line}
            </p>)}
        </div>

        <ul className="mt-5 grid max-w-3xl gap-x-8 gap-y-2 border-l border-champagne/40 pl-4 sm:grid-cols-2" data-id="element-257" data-mp="22bkwc2s9urwk">
          {painQuestions.map(q => <li key={q} className="font-display text-[1.1rem] italic leading-snug text-ivory-100 sm:text-xl" data-id="element-258" data-mp="3rm97t0oci8tk">
              {q}
            </li>)}
        </ul>

        <p className="mt-7 max-w-2xl text-[15px] leading-relaxed text-body sm:text-[16px]" data-id="element-259" data-mp="5fsreqcip1eu">
          {PAIN_EMPHASIS_LEAD}{' '}
          <span className="font-medium text-ivory-50" data-id="element-260" data-mp="gg8uhsoigi2">{PAIN_EMPHASIS}</span>
        </p>

        <ul className="mt-8 grid gap-x-10 border-t border-charcoal-600 sm:grid-cols-2" data-id="element-261" data-mp="38vzyl6u55gsd">
          {painLines.map(line => <li key={line} className="flex items-start gap-3 border-b border-charcoal-600 py-4" data-id="element-262" data-mp="33yrbqsy1soks">
              <XIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-rose-deep" strokeWidth={3} aria-hidden="true" data-id="element-263" data-mp="3in4ce382yvlm" />
              <span className="text-[14px] font-medium leading-snug text-ivory-100" data-id="element-264" data-mp="3du1hnrrkhg3u">{line}</span>
            </li>)}
        </ul>

        <p className="mt-9 max-w-2xl font-display text-xl font-semibold uppercase leading-snug text-champagne-light sm:text-[1.75rem]" data-id="element-265" data-mp="2l6yicxf2h1cj">
          {PAIN_CLOSING}
        </p>
      </div>
    </section>;
}